import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

const BASE = '/';
const apiFetch = (path, method = 'GET', body) =>
  fetch(`${BASE}${path}`, {
    method,
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('token')}` },
    body: body ? JSON.stringify(body) : undefined,
  }).then(r => r.json());

const SEGMENTOS = [
  'Restaurante', 'Salão de beleza', 'Academia', 'Clínica odontológica', 'Clínica médica',
  'Farmácia', 'Supermercado', 'Padaria', 'Escola', 'Advocacia',
  'Contabilidade', 'Imobiliária', 'Loja de roupas', 'Pet shop', 'Oficina mecânica',
  'Hotel', 'Pousada', 'Lanchonete', 'Sorveteria', 'Clínica veterinária',
];

export default function GoogleMaps() {
  const navigate = useNavigate();
  const [apiKey, setApiKey] = useState('');
  const [apiKeySalva, setApiKeySalva] = useState('');
  const [salvando, setSalvando] = useState(false);
  const [segmento, setSegmento] = useState('');
  const [cidade, setCidade] = useState('');
  const [buscando, setBuscando] = useState(false);
  const [resultados, setResultados] = useState([]);
  const [erro, setErro] = useState('');
  const [nextPageToken, setNextPageToken] = useState(null);
  const [carregandoMais, setCarregandoMais] = useState(false);

  useEffect(() => {
    apiFetch('apis/google-maps/config').then(d => {
      if (d.apiKey) { setApiKey(d.apiKey); setApiKeySalva(d.apiKey); }
    }).catch(() => {});
  }, []);

  const salvarChave = async () => {
    setSalvando(true);
    setErro('');
    try {
      const r = await apiFetch('apis/google-maps/config', 'POST', { apiKey });
      if (r.erro) throw new Error(r.erro);
      setApiKeySalva(apiKey);
    } catch (e) {
      setErro(`Não salvou: ${e.message || 'falha na comunicação'}`);
    } finally {
      setSalvando(false);
    }
  };

  const buscar = useCallback(async (token = null) => {
    if (!segmento || !cidade) return;
    if (!apiKeySalva) { setErro('Configure a chave da API primeiro.'); return; }
    setErro('');
    if (token) setCarregandoMais(true); else { setBuscando(true); setResultados([]); }
    const resp = await apiFetch(`apis/google-maps/buscar?segmento=${encodeURIComponent(segmento)}&cidade=${encodeURIComponent(cidade)}${token ? `&pagetoken=${encodeURIComponent(token)}` : ''}`);
    if (resp.erro) { setErro(resp.erro); }
    else {
      setResultados(prev => token ? [...prev, ...resp.resultados] : resp.resultados);
      setNextPageToken(resp.nextPageToken || null);
    }
    setBuscando(false); setCarregandoMais(false);
  }, [segmento, cidade, apiKeySalva]);

  const chaveConfigurada = !!apiKeySalva;

  return (
    <div style={{ padding: 24, maxWidth: 1100, margin: '0 auto' }}>

      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 24 }}>
        <button onClick={() => navigate('/apis')} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#6b7280', fontSize: 20, lineHeight: 1, padding: 0 }}>←</button>
        <div>
          <h1 style={{ margin: 0, fontSize: 20, color: '#0a1628', fontWeight: 800 }}>📍 Google Maps Places</h1>
          <p style={{ margin: 0, fontSize: 13, color: '#6b7280' }}>Localiza empresas por segmento e região</p>
        </div>
      </div>

      {/* Config da API Key */}
      <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 14, padding: 20, marginBottom: 20, boxShadow: '0 1px 6px rgba(0,0,0,0.05)' }}>
        <div style={{ fontWeight: 700, fontSize: 14, color: '#0a1628', marginBottom: 10 }}>
          🔑 Chave da API — Google Maps Platform
          {chaveConfigurada && <span style={{ marginLeft: 8, fontSize: 11, color: '#16a34a', fontWeight: 600 }}>● Configurada</span>}
        </div>
        <div style={{ display: 'flex', gap: 10 }}>
          <input
            type="password"
            value={apiKey}
            onChange={e => setApiKey(e.target.value)}
            placeholder="AIzaSy..."
            style={{ flex: 1, padding: '9px 14px', border: '1px solid #e5e7eb', borderRadius: 8, fontSize: 14, fontFamily: 'monospace' }}
          />
          <button
            onClick={salvarChave}
            disabled={salvando || !apiKey}
            style={{ padding: '9px 20px', background: '#4285F4', color: '#fff', border: 'none', borderRadius: 8, fontWeight: 700, fontSize: 14, cursor: 'pointer' }}
          >
            {salvando ? 'Salvando...' : 'Salvar'}
          </button>
        </div>
        <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 6 }}>
          Ative a <strong>Places API</strong> no Google Cloud Console e gere uma chave com restrição de IP ou HTTP referrer.
        </div>
      </div>

      {/* Busca */}
      <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 14, padding: 20, marginBottom: 20, boxShadow: '0 1px 6px rgba(0,0,0,0.05)' }}>
        <div style={{ fontWeight: 700, fontSize: 14, color: '#0a1628', marginBottom: 14 }}>🔍 Pesquisar Empresas</div>
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
          <div style={{ flex: '1 1 220px' }}>
            <label style={{ fontSize: 12, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 4 }}>Segmento</label>
            <input
              list="segmentos"
              value={segmento}
              onChange={e => setSegmento(e.target.value)}
              placeholder="Ex: Salão de beleza"
              style={{ width: '100%', padding: '10px 14px', border: '1px solid #e5e7eb', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' }}
            />
            <datalist id="segmentos">
              {SEGMENTOS.map(s => <option key={s} value={s} />)}
            </datalist>
          </div>
          <div style={{ flex: '1 1 220px' }}>
            <label style={{ fontSize: 12, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 4 }}>Cidade / Região</label>
            <input
              value={cidade}
              onChange={e => setCidade(e.target.value)}
              placeholder="Ex: Natal - RN"
              style={{ width: '100%', padding: '10px 14px', border: '1px solid #e5e7eb', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' }}
            />
          </div>
          <div style={{ display: 'flex', alignItems: 'flex-end' }}>
            <button
              onClick={() => buscar()}
              disabled={buscando || !segmento || !cidade || !chaveConfigurada}
              style={{
                padding: '10px 28px', background: buscando ? '#d1d5db' : 'linear-gradient(135deg,#4285F4,#3367D6)',
                color: '#fff', border: 'none', borderRadius: 8, fontWeight: 700, fontSize: 14,
                cursor: buscando ? 'default' : 'pointer', whiteSpace: 'nowrap',
              }}
            >
              {buscando ? '🔍 Buscando...' : '🔍 Buscar'}
            </button>
          </div>
        </div>
        {erro && <div style={{ marginTop: 10, padding: '10px 14px', background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 8, fontSize: 13, color: '#dc2626' }}>{erro}</div>}
      </div>

      {/* Resultados */}
      {resultados.length > 0 && (
        <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 14, overflow: 'hidden', boxShadow: '0 1px 6px rgba(0,0,0,0.05)' }}>
          <div style={{ padding: '14px 20px', borderBottom: '1px solid #f3f4f6', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ fontWeight: 700, fontSize: 14, color: '#0a1628' }}>
              {resultados.length} empresa{resultados.length !== 1 ? 's' : ''} encontrada{resultados.length !== 1 ? 's' : ''}
            </div>
            <div style={{ fontSize: 12, color: '#6b7280' }}>{segmento} · {cidade}</div>
          </div>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
              <thead>
                <tr style={{ background: '#f9fafb' }}>
                  {['Nome', 'Endereço', 'Avaliação', 'Tipo'].map(h => (
                    <th key={h} style={{ padding: '10px 16px', textAlign: 'left', fontWeight: 700, color: '#374151', fontSize: 12, borderBottom: '1px solid #f3f4f6', whiteSpace: 'nowrap' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {resultados.map((r, i) => (
                  <tr key={i} style={{ borderBottom: '1px solid #f9fafb' }}
                    onMouseEnter={e => e.currentTarget.style.background = '#f9fafb'}
                    onMouseLeave={e => e.currentTarget.style.background = ''}
                  >
                    <td style={{ padding: '12px 16px', fontWeight: 600, color: '#0a1628' }}>
                      {r.nome}
                    </td>
                    <td style={{ padding: '12px 16px', color: '#6b7280', maxWidth: 260 }}>
                      {r.endereco || '—'}
                    </td>
                    <td style={{ padding: '12px 16px', whiteSpace: 'nowrap' }}>
                      {r.avaliacao ? (
                        <span style={{ color: '#f59e0b', fontWeight: 700 }}>
                          ★ {r.avaliacao} <span style={{ color: '#9ca3af', fontWeight: 400 }}>({r.totalAvaliacoes})</span>
                        </span>
                      ) : '—'}
                    </td>
                    <td style={{ padding: '12px 16px', color: '#6b7280', maxWidth: 200 }}>
                      <span style={{ background: '#f3f4f6', padding: '2px 8px', borderRadius: 20, fontSize: 11 }}>
                        {r.tipo || '—'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {nextPageToken && (
            <div style={{ padding: '14px 20px', borderTop: '1px solid #f3f4f6', textAlign: 'center' }}>
              <button
                onClick={() => buscar(nextPageToken)}
                disabled={carregandoMais}
                style={{ padding: '10px 28px', background: '#f3f4f6', border: '1px solid #e5e7eb', borderRadius: 8, fontWeight: 700, fontSize: 13, cursor: 'pointer' }}
              >
                {carregandoMais ? 'Carregando...' : 'Carregar mais resultados'}
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
